import { render, staticRenderFns } from "./ExecLoyalty.vue?vue&type=template&id=06c410c2"
import script from "./ExecLoyalty.vue?vue&type=script&lang=js"
export * from "./ExecLoyalty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports